<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box p-0">
        <a routerLink="/dashboard" class="logo logo-dark">
          <span class="logo-sm">
            <img
              src="../../../assets/images/logos/logoIS.png"
              alt=""
              height="20"
            />
          </span>
          <span class="logo-lg">
            <img
              src="../../../assets/images/logos/logoIS.png"
              alt=""
              height="50"
            />
          </span>
        </a>

        <a routerLink="/dashboard" class="logo logo-light">
          <span class="logo-sm">
            <img
              src="../../../assets/images/logos/logo-wkf-tracker.svg"
              alt=""
              height="20"
            />
          </span>
          <span class="logo-lg">
            <img
              src="../../../assets/images/logos/logo-wkf-tracker.svg"
              alt=""
              height="50"
            />
          </span>
        </a>
      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <div class="d-flex align-items-center">
        <span>v.{{ version }}</span>
      </div>
    </div>

    <div class="d-flex align-items-center gap-3">
      <!-- Seletor de Linguagem -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item"
          id="page-header-language-dropdown"
          ngbDropdownToggle
          [attr.aria-label]="'Selecionar idioma: ' + countryName"
        >
          <img [src]="flagvalue" [alt]="countryName" height="16" />
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <a
            *ngFor="let item of listLang"
            href="javascript:void(0);"
            class="dropdown-item notify-item"
            (click)="setLanguage(item.text, item.lang, item.flag, item.value)"
            [ngClass]="{ active: cookieValue === item.lang }"
          >
            <img [src]="item.flag" [alt]="item.text" class="me-1" height="12" />
            <span class="align-middle">{{ item.text }}</span>
          </a>
        </div>
      </div>

      <!-- Seletor de Prestador de Serviço (apenas para ADMINISTRATOR) -->
      <div
        class="d-flex align-items-center gap-2"
        *ngIf="profile === 'ADMINISTRATOR'"
      >
        <i
          class="fas fa-sync-alt refresh-icon"
          (click)="getServiceProviders()"
          title="Atualizar prestadores"
          style="cursor: pointer"
        ></i>

        <ng-select
          class="custom-ngselect w-100"
          [items]="serviceProviders"
          bindLabel="name"
          bindValue="serviceProviderId"
          [ngModel]="serviceProviderIdSelected"
          (ngModelChange)="onServiceProviderChange($event)"
          placeholder="Selecione um prestador"
          [clearable]="false"
        >
        </ng-select>
      </div>

      <!-- Seletor de Prestador de Serviço para Matriz -->
      <!-- <div class="d-flex align-items-center gap-2" *ngIf="isHeadquarter">
        <i
          class="fas fa-sync-alt refresh-icon"
          (click)="getServiceProviders()"
          title="Atualizar prestadores"
          style="cursor: pointer"
        ></i>

        <ng-select
          class="custom-ngselect w-100"
          [items]="headquartersServiceProviders"
          bindLabel="name"
          bindValue="serviceProviderId"
          [ngModel]="serviceProviderIdSelected"
          (ngModelChange)="onServiceProviderChange($event)"
          placeholder="Selecione uma Filial"
          [clearable]="false"
        >
        </ng-select>
      </div> -->

      <!-- Notificações de Processamento -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item noti-icon"
          ngbDropdownToggle
          id="page-header-notifications-dropdown"
          (click)="onNotificationBellClick()"
        >
          <i class="bx bx-bell"></i>
          <span class="badge bg-danger rounded-pill" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">{{ 'PROCESSING_LOG.NOTIFICATIONS' | translate }}</h6>
              </div>
              <div class="col-auto">
                <a href="javascript:void(0);" class="small" (click)="markAllNotificationsAsRead()" *ngIf="unreadCount > 0">
                  {{ 'PROCESSING_LOG.MARK_ALL_READ' | translate }}
                </a>
              </div>
            </div>
          </div>
          <div style="max-height: 230px; overflow-y: auto;">
            <a
              *ngFor="let log of recentLogs"
              href="javascript:void(0);"
              class="text-reset notification-item"
              (click)="onNotificationClick(log)"
            >
              <div class="d-flex" [ngClass]="{ 'bg-light': !log.isRead }">
                <div class="flex-shrink-0 me-3">
                  <div class="avatar-xs">
                    <span
                      class="avatar-title rounded-circle"
                      [ngClass]="{
                        'bg-danger': log.status === 2,
                        'bg-warning': log.status === 3,
                        'bg-success': log.status === 1,
                        'bg-info': log.status === 4
                      }"
                    >
                      <i
                        class="bx"
                        [ngClass]="{
                          'bx-x': log.status === 2,
                          'bx-error': log.status === 3,
                          'bx-check': log.status === 1,
                          'bx-minus': log.status === 4
                        }"
                      ></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-1">{{ 'PROCESSING_LOG.ACTION.' + log.action | translate }}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-0">{{ log.messageDescription || log.messageCode }}</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i> {{ log.dtCreation | date:'dd/MM/yyyy HH:mm' }}</p>
                  </div>
                </div>
              </div>
            </a>
            <div *ngIf="recentLogs.length === 0" class="p-3 text-center text-muted">
              {{ 'PROCESSING_LOG.NO_NOTIFICATIONS' | translate }}
            </div>
          </div>
          <div class="p-2 border-top d-grid">
            <a href="javascript:void(0);" class="btn btn-sm btn-link font-size-14 text-center" routerLink="/processing-logs">
              <i class="mdi mdi-arrow-right-circle me-1"></i> {{ 'PROCESSING_LOG.VIEW_ALL' | translate }}
            </a>
          </div>
        </div>
      </div>

      <!-- Dropdown Usuário -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item"
          ngbDropdownToggle
          id="page-header-user-dropdown"
        >
          <img
            class="rounded-circle header-profile-user"
            src="../../../assets/images/users/avatar-wkf.svg"
            alt="Header Avatar"
          />
          <span class="d-none d-xl-inline-block ms-1">{{ username }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>

        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <a
            class="dropdown-item text-danger"
            href="javascript:void(0);"
            (click)="logout()"
          >
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            Sair
          </a>
        </div>
      </div>
    </div>
  </div>
</header>
